import { ImpulseFormUnit } from "~/tools/impulse-form";

const DEFAULT = true;

type WidgetSparkline = ImpulseFormUnit<boolean>;

function init(initial = DEFAULT): WidgetSparkline {
	return ImpulseFormUnit(initial);
}

const WidgetSparkline = {
	default: DEFAULT,
	init,
} as const;

export { WidgetSparkline };
